export default __webpack_public_path__ + "assets/images/g-infos-bg-a714a26d.png";